import { Component, OnInit, Input, EventEmitter, OnDestroy } from '@angular/core';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { DepartmentService } from '../../services/department.service';
import { AssistanceService } from '../../services/assistance.service';
import { EmployeeService } from '../../services/employee.service';
import { CheckClockService } from '../../services/check-clock.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { Router } from '@angular/router';

@Component({
    selector: 'app-display-assistance',
    templateUrl: './display-assistance.component.html',
    styleUrls: ['./display-assistance.component.css', '../../app.component.css']
})

export class DisplayAssistanceComponent implements OnInit, OnDestroy {
    allowed: boolean = false;
    permission: any = {};

    pickadateParams = Utils.pickadateParamsNoBlank();

    weekday: number;
    textday: string;
    paymentPeriod: string;

    _startDate = '';
    endDate: any;

    errorText = '';

    departments = {};
    departmentInit: any;
    departmentText = '';

    runningFlag = false;
    createAction = false;
    updateAction = false;

    globalActions = new EventEmitter<string|MaterializeAction>();
    globalActionsRunning = new EventEmitter<string|MaterializeAction>();

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Empleado', name: 'employeeName', sort: 'asc' },
        { title: 'Días puntuales', className: 'center', name: 'daysOnTime' },
        { title: 'Días impuntuales', className: 'center', name: 'daysNotOnTime' },
        { title: 'No asistió', className: 'center',  name: 'daysNotAttend' },
        { title: 'Días inhábiles', className: 'center',  name: 'daysNonWorking' }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' }
    };

    loadText = 0;

    processEnd = false;

    entryTime = '';
    businessDays = [];

    employeesData = [];

    gaSubs: any;
    gpsSubs: any;
    gdSubs: any;
    geSubs: any;
    gccbrdSubs: any;
    gaeSubs: any;

    permissions = [];
    permissionsSubs: any;

    constructor(
        private catalogsSettingsService: CatalogsSettingsService,
        private departmentService: DepartmentService,
        private service: AssistanceService,
        private employeeService: EmployeeService,
        private checkClockService: CheckClockService,
        private authService: AuthService,
        private permissionService: PermissionService,
        private router: Router
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });

        this.gpsSubs = this.catalogsSettingsService.getPayrollSettings('1').subscribe(payrollObj => {
            this.gpsSubs.unsubscribe();

            if (payrollObj.startDay === 'sunday') {
                this.weekday = 0;
                this.textday = 'Domingo';
            } else if (payrollObj.startDay === 'monday') {
                this.weekday = 1;
                this.textday = 'Lunes';
            } else if (payrollObj.startDay === 'tuesday') {
                this.weekday = 2;
                this.textday = 'Martes';
            } else if (payrollObj.startDay === 'wednesday') {
                this.weekday = 3;
                this.textday = 'Miércoles';
            } else if (payrollObj.startDay === 'thursday') {
                this.weekday = 4;
                this.textday = 'Jueves';
            } else if (payrollObj.startDay === 'friday') {
                this.weekday = 5;
                this.textday = 'Viernes';
            } else if (payrollObj.startDay === 'saturday') {
                this.weekday = 6;
                this.textday = 'Sábado';
            }

            this.entryTime = payrollObj.entryTime + ':59';
            this.businessDays = payrollObj.businessDays;
            this.paymentPeriod = payrollObj.paymentPeriod;
        });

        this.loadDepartments();
    }

    ngOnInit() {

    }

    @Input()
    set startDate(_startDate: string) {
        this._startDate = _startDate;

        this.departmentText = '';

        this.processEnd = false;

        this.data = [];
        this.length = this.data.length;
        this.onChangeTable(this.config);

        this.createAction = false;
        this.updateAction = false;

        const weekdaySelected = Utils.convertDatefromISOStringtoObject(this._startDate);

        if (weekdaySelected.getDay() === this.weekday || this.paymentPeriod != 'weekly') {
            const toDate = weekdaySelected;
            toDate.setDate(toDate.getDate() + 6);

            this.endDate = toDate.getFullYear() + '-' +
                           ('0' + (toDate.getMonth() + 1)).slice(-2) + '-' +
                           ('0' + toDate.getDate()).slice(-2);

            if (this._startDate !== '' && this._startDate !== undefined && this.endDate !== '' && this.endDate !== undefined) {
                const assistanceId = this._startDate + '_' + this.endDate;

                this.gaSubs = this.service.getAssistance(assistanceId).subscribe(assistanceObj => {
                    this.gaSubs.unsubscribe();

                    if (assistanceObj !== null) {
                        console.log('GET : update');

                        this.runningFlag = true;
                        this.processEnd = false;

                        this.showAssistance(assistanceId, 1);

                        this.updateAction = true;
                    } else {
                        console.log('NEW : create');
                        this.createAction = true;
                    }
                });
            } else {
                this.globalActions.emit('toast');
            }
        } else {
            this.endDate = undefined;
            this.errorText = 'El día de inicio de la nómina son los días ' + this.textday;
        }
    }

    get startDate(): string {
        return this._startDate;
    }

    changeDate() {
        this.errorText = '';
    }

    loadDepartments() {
        this.gdSubs = this.departmentService.getDepartments().subscribe(tempDepartments => {
            const dataDepartment = {};

            for (const idx in tempDepartments) {
                dataDepartment[tempDepartments[idx].name] = null;
                this.departments[tempDepartments[idx].name] = tempDepartments[idx].id$;
            }

            this.departmentInit = {
                'data': dataDepartment,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.departments[val]);
                }
            };
        });
    }

    onBlurDepartment() {
        this.data = [];
        this.length = this.data.length;
        this.onChangeTable(this.config);

        if (this.departments[this.departmentText] === undefined) {
            this.departmentText = '';

            this.data = this.employeesData;
            this.length = this.data.length;
            this.onChangeTable(this.config);
        } else {
            const filterData = [];

            for (const idxEd in this.employeesData) {
                if (this.employeesData[idxEd].employeeDepartmentId === this.departments[this.departmentText]) {
                    filterData.push(this.employeesData[idxEd]);
                }
            }

            this.data = filterData;
            this.length = this.data.length;
            this.onChangeTable(this.config);
        }
    }

    createReport() {
        if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
        if (this.runningFlag === false) {
            console.log('Create assistance');

            this.runningFlag = true;

            this.loadCheckClocks();
        } else {
            this.globalActionsRunning.emit('toast');
        }
    }

    updateReport() {
        if(!this.permission.createAction || !this.permission.updateAction) return toast('No tiene los permisos para actualizar.', 2000);
        if (this.runningFlag === false) {
            console.log('Update assistance');

            this.departmentText = '';

            this.data = [];
            this.length = this.data.length;
            this.onChangeTable(this.config);

            this.runningFlag = true;
            this.processEnd = false;

            const iAssistanceId = this._startDate + '_' + this.endDate;

            this.service.delAssistance(iAssistanceId).then(res => {
                console.log('Deleted old assistance');

                this.loadCheckClocks();
            });
        } else {
            this.globalActionsRunning.emit('toast');
        }
    }

    loadCheckClocks() {
        this.loadText = 1;

        const sDate = Utils.convertDatefromISOStringtoObject(this._startDate);
        const eDate = Utils.convertDatefromISOStringtoObject(this.endDate);

        const dates = [];

        while (sDate <= eDate) {
            dates.push(String(Utils.getDateWhitoutTime(sDate)));
            sDate.setDate(sDate.getDate() + 1);
        }

        console.log(dates);

        let totalDaysNonWorking = 0;

        for (let _i = 0; _i < this.businessDays.length; _i++) {
            if (this.businessDays[_i] === false) {
                totalDaysNonWorking = totalDaysNonWorking + 1;
            }
        }

        const employees: any[] = [];

        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployeesData => {
            this.geSubs.unsubscribe();
            console.log('Get employees data');

            for (const idxEd in tempEmployeesData) {
                const itemId = tempEmployeesData[idxEd].id$.toString();

                employees[itemId] = {
                    employeeId: itemId,
                    employeeName: tempEmployeesData[idxEd].name + ' ' + tempEmployeesData[idxEd].lastName,
                    days: dates,
                    inDays: new Array(dates.length).fill(0),
                    daysOnTime: 0,
                    daysNotOnTime: 0,
                    daysNotAttend: 0,
                    daysNonWorking: totalDaysNonWorking,
                    departmentId: tempEmployeesData[idxEd].departmentId
                };
            }

            this.loadText = 2;

            this.processByDate(employees, dates, 0);
        });
    }

    processByDate(employees, dates, index) {
        console.log('Day : ' +  index + ' : ' + dates[index]);

        this.gccbrdSubs = this.checkClockService.getCheckClocksByRegistrationDate(dates[index]).subscribe(tempCheckClocks => {
            this.gccbrdSubs.unsubscribe();
            console.log('Get check clock data');

            for (const idxCc in tempCheckClocks) {
                if (tempCheckClocks[idxCc].employeeId !== '') {
                    let employeeId = tempCheckClocks[idxCc].employeeId.toString();

                    if (employees[employeeId] !== undefined) {
                        if (tempCheckClocks[idxCc].type === 0) { // ENTRADA
                            // console.log(tempCheckClocks[idxCc].employeeId + ' : ' + tempCheckClocks[idxCc].registrationDate + ' : ' + tempCheckClocks[idxCc].registrationTime);

                            let weekDay = Utils.convertDatefromISOStringtoObject(tempCheckClocks[idxCc].registrationDate + ' 00:00:00').getDay();

                            if (this.businessDays[weekDay] === true) {
                                let positionDay = employees[employeeId].days.indexOf(tempCheckClocks[idxCc].registrationDate);

                                if (tempCheckClocks[idxCc].registrationTime <= this.entryTime) {
                                    // console.log(tempCheckClocks[idxCc].registrationTime + ' : ' + this.entryTime + ' : ON_TIME');

                                    if (employees[employeeId].inDays[positionDay] === 0) {
                                        employees[employeeId].inDays[positionDay] = 1;

                                        employees[employeeId].daysOnTime = employees[employeeId].daysOnTime + 1;
                                    }
                                } else  {
                                    // console.log(tempCheckClocks[idxCc].registrationTime + ' : ' + this.entryTime + ' : LATE');

                                    if (employees[employeeId].inDays[positionDay] === 0) {
                                        employees[employeeId].inDays[positionDay] = 1;

                                        employees[employeeId].daysNotOnTime = employees[employeeId].daysNotOnTime + 1;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if ((index + 1) === dates.length) {
                console.log('Save Assistance');

                const currentDate = new Date();

                const assistanceJson = {
                    active: true,
                    createdAt: currentDate,
                    endDate: dates[dates.length - 1],
                    startDate: dates[0],
                    updatedAt: currentDate
                };

                const assistanceId = dates[0] + '_' + dates[dates.length - 1];

                this.service.postAssistance(assistanceId, assistanceJson).then(responseId => {
                    if (responseId !== '') {
                        let counter = 0;
                        const employeesAssistance = [];

                        for (const idx in employees) {
                            counter = counter + 1;

                            const employeeJson = {
                                createdAt: currentDate,
                                daysOnTime: employees[idx].daysOnTime,
                                daysNotOnTime: employees[idx].daysNotOnTime,
                                daysNotAttend: (7 - ((employees[idx].daysOnTime + employees[idx].daysNotOnTime) + employees[idx].daysNonWorking)),
                                daysNonWorking: employees[idx].daysNonWorking,
                                employeeId: employees[idx].employeeId,
                                employeeDepartmentId: employees[idx].departmentId,
                                employeeName: employees[idx].employeeName,
                                updatedAt: currentDate
                            };

                            employeesAssistance.push(employeeJson);
                        }

                        const sizeBatch = 500;
                        const numberBatchs = Math.floor(counter / sizeBatch) + (counter % sizeBatch === 0 ? 0 : 1);

                        this.loadText = 3;

                        this.processAssistance(this, employeesAssistance, counter, sizeBatch, numberBatchs, 1, responseId);
                    }
                });
            } else {
                this.processByDate(employees, dates, (index + 1));
            }
        });
    }

    processAssistance(self, employees, totalEmployees, itemsToProcess, totalOfProcess, iProcess, assistanceId) {
        console.log('Iteration : ' + iProcess + ' / ' + totalOfProcess);

        if (totalOfProcess === iProcess) {
            const arrayEmployees = Object.values(employees);

            self.service.postAssistanceEmployeesAtomic(assistanceId, arrayEmployees).then(function() {
                self.showAssistance(assistanceId, 0);
            });
        } else {
            const arrayEmployees = Object.values(employees);
            const processingEmployees = arrayEmployees.splice(0, itemsToProcess);
            const remainingEmployees = arrayEmployees.splice(0, (totalEmployees - itemsToProcess));

            self.service.postAssistanceEmployeesAtomic(assistanceId, processingEmployees).then(function() {
                self.processAssistance(self, remainingEmployees, (totalEmployees - itemsToProcess), itemsToProcess,
                                        totalOfProcess, (iProcess + 1), assistanceId);
            });
        }
    }

    showAssistance(assistanceId, type) {
        console.log('Show results');

        this.loadText = 4;

        this.gaeSubs = this.service.getAssistanceEmployees(assistanceId).subscribe(payrollObj => {
            this.gaeSubs.unsubscribe();

            this.employeesData = payrollObj[0].employees;

            this.data = this.employeesData;
            this.length = this.data.length;
            this.onChangeTable(this.config);

            if (type === 0) {
                this.createAction = false;
                this.updateAction = true;
            }

            this.runningFlag = false;
            this.loadText = 0;
            this.processEnd = true;
        });
    }

    ngOnDestroy() {
        this.gdSubs.unsubscribe();
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}
